module.exports = "/_next/static/images/33b06a247dcd6ac636e757a0f9a4700c-press-media.jpg.webp";